var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_c('message-preview',{attrs:{"index":0,"action":"expanded"}}),_c('message-display',{attrs:{"index":"0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }